// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientTasks_ClientDetail__WnXQd","tableResponsive":"ClientTasks_tableResponsive__-x4jR"};